import React from 'react';
import PropTypes from 'prop-types';
import { reduxForm } from 'redux-form';
import { connect } from 'react-redux';
import { createLayout, fetchFieldsById } from '../../actions/superadmin';
import { storeWithExpiration } from '../../utils/common';
import UploadLayoutForm from './UploadLayoutForm';

const FORM_ID = 'layoutForm';

export class UploadLayoutFormContainer extends React.Component {
  static propTypes = {
    invalid: PropTypes.bool.isRequired,
    pristine: PropTypes.bool.isRequired,
    handleSubmit: PropTypes.func.isRequired,
    submitting: PropTypes.bool.isRequired,
    reset: PropTypes.func.isRequired,
    createLayoutAction: PropTypes.func.isRequired,
    fetchFieldsByIdAction: PropTypes.func.isRequired,
    pageChangeFunction: PropTypes.func.isRequired,
    datasetId: PropTypes.number.isRequired,
    preExistingValues: PropTypes.object.isRequired,
  };

  createLayout = params => {
    const { createLayoutAction, datasetId, fetchFieldsByIdAction, preExistingValues } = this.props;
    const token = storeWithExpiration.get('token');
    const layoutData = {
      datasetId: datasetId.toString(),
      filesetId: preExistingValues.id.toString(),
      file: params.layoutFiles[0],
      codes: params.codeFiles !== undefined ? params.codeFiles[0] : null,
    };

    const prom = new Promise(resolve => {
      createLayoutAction(token, layoutData, resolve);
    });
    prom.then(() => {
      fetchFieldsByIdAction(token, datasetId, preExistingValues.id);
    });
  };

  render() {
    const { invalid, pristine, handleSubmit, submitting, reset, pageChangeFunction } = this.props;
    return (
      <div>
        <UploadLayoutForm
          invalid={invalid}
          pristine={pristine}
          handleSubmit={handleSubmit}
          createLayoutFunction={this.createLayout}
          submitting={submitting}
          reset={reset}
          pageChangeFunction={pageChangeFunction}
        />
      </div>
    );
  }
}

const validate = values => {
  const errors = {};
  if (!values.layoutFiles || values.layoutFiles === '') {
    errors.layoutFiles = 'Required';
  }
  if (values.dataSetSelect < 1) {
    errors.dataSetSelect = 'Required';
  }
  return errors;
};

const UploadLayoutFormContainerRF = reduxForm({
  form: FORM_ID,
  initialValues: { layoutFiles: null },
  validate,
})(UploadLayoutFormContainer);

export default connect(null, {
  createLayoutAction: createLayout,
  fetchFieldsByIdAction: fetchFieldsById,
})(UploadLayoutFormContainerRF);
